<template>
<div class="success-page">
    <div class="text-center">
        <svg class="mb-4"
            width="55"
            height="55"
            viewBox="0 0 55 55"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M27.5 0C12.336 0 0 12.336 0 27.5C0 42.664 12.336 55 27.5 55C42.664 55 55 42.664 55 27.5C55 12.336 42.664 0 27.5 0Z"
                fill="#54D854"
                fill-opacity="0.27"
            />
            <path
                d="M27.5 55C12.336 55 0 42.664 0 27.5C0 12.336 12.336 0 27.5 0C42.664 0 55 12.336 55 27.5C55 42.664 42.664 55 27.5 55ZM27.5 3.4375C14.2313 3.4375 3.4375 14.2313 3.4375 27.5C3.4375 40.7688 14.2313 51.5625 27.5 51.5625C40.7688 51.5625 51.5625 40.7688 51.5625 27.5C51.5625 14.2313 40.7688 3.4375 27.5 3.4375Z"
                fill="#54D854"
            />
            <path
                d="M24.922 36.6671C24.482 36.6671 24.042 36.4998 23.7074 36.1629L16.2595 28.715C15.588 28.0435 15.588 26.955 16.2595 26.2835C16.9309 25.6121 18.0195 25.6121 18.6909 26.2835L24.9242 32.5169L38.6055 18.8356C39.277 18.1642 40.3655 18.1642 41.037 18.8356C41.7084 19.5071 41.7084 20.5956 41.037 21.2671L26.1411 36.1629C25.802 36.4998 25.362 36.6671 24.922 36.6671Z"
                fill="#54D854"
            />
        </svg>

        <h3 id="title">
            Strata Plan {{ form.strata_plan_number }} has been {{text_created_updated}}!
        </h3>

        <div class="bb mx-auto">
        
        <b-button
            v-if="redirectToCreateWorkOrder"
            class="btn-grad mx-auto"
            type="button"
            variant="primary"
            :to="{ name: 'manager-workorder-edit', params: { id: 'new', step: 1 } }"
            >Return to Work Order</b-button
        >
          <b-button
            v-else-if="redirectToCreateQuote"
            class="btn-grad mx-auto"
            type="button"
            variant="primary"
            :to="{ name: 'manager-quote-edit', params: { id: 'new', step: 1 } }"
            >Return to Quote</b-button
        >
        <b-button
            v-else
            class="btn-grad mx-auto"
            type="button"
            variant="primary"
            :to="{ name: 'strata-plan'}"
            >Continue to Strata Plan</b-button
        >
        </div>
    </div>
</div>
</template>

<script>
import NavBar from "../../includes/NavBar.vue";
import { HasError } from "vform";

export default {
    props: ["form", "createdUpdatedText"],
    components: {
        NavBar,
        HasError
    },
    data() {
        return {
            text_created_updated:'',
            redirectToCreateWorkOrder: false,
            redirectToCreateQuote: false,
        };
    },
    mounted() {
        this.createdOrUpdated();
        sessionStorage.getItem('addStrataPlanFromWorkorder') ? this.redirectToCreateWorkOrder = true : this.redirectToCreateWorkOrder = false;
        sessionStorage.getItem('addStrataPlanFromQuote') ? this.redirectToCreateQuote = true : this.redirectToCreateQuote = false;
    },
    methods: {
        createdOrUpdated(){
            this.text_created_updated = this.createdUpdatedText
        }
    }
};
</script>
